import React from 'react';
import PropTypes from 'prop-types';
import { SectionWrapper } from 'src/components/Reports/Report.style';
import ReportsFilter from './ReportsFilter';
import { ReportsListNew } from './ReportsList/ReportsListNew.tsx';

class Report extends React.PureComponent {
    render() {
        return (
            <SectionWrapper className='reports'>
                <ReportsFilter />
                <ReportsListNew />
            </SectionWrapper>
        );
    }
}

export default Report;
